import requestService from '~/services/requestsService';

const basePath = 'review-likes';

const toggleLike = async (reviewId: string) => {
  const response = await requestService.post<{ isLiked: boolean }>(
    `${basePath}/${reviewId}/toggle`
  );
  return response?.data;
};

const getLikeCount = async (reviewId: string) => {
  const response = await requestService.fetch<{ count: number }>(
    `${basePath}/${reviewId}/count`
  );
  return response ?? { count: 0 };
};

const getLikeStatus = async (reviewId: string) => {
  const response = await requestService.fetch<{ isLiked: boolean }>(
    `${basePath}/${reviewId}/status`
  );
  return response ?? { isLiked: false };
};

const reviewLikesService = {
  toggleLike,
  getLikeCount,
  getLikeStatus,
};

export default reviewLikesService; 